import React from 'react';
import { MapContainer as Map } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Card } from '@mui/material';
import { useSelector } from 'react-redux';
import { isEqual } from 'underscore';

import { RootState } from '@/index';
import { TerritoryMapContent } from './TerritoryMapContent';

function toLatLng(coords: unknown): [number, number] | null {
  // coords expected as GeoJSON point: [lng, lat]
  if (!Array.isArray(coords) || coords.length < 2) return null;
  const lng = Number(coords[0]);
  const lat = Number(coords[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lat, lng];
}

export const TerritoryMap = () => {
  const { core: { companyAddress } } = useSelector((state: RootState) => state, isEqual);

  const depotLocation =
    toLatLng(companyAddress?.location?.coordinates) ?? [52.52, 13.405];

  return (
    <Card style={{ padding: 5, height: window.innerHeight - 96 }}>
      <Map
        style={{ height: window.innerHeight - 106, zIndex: 99 }}
        center={depotLocation}
        zoom={9}
      >
        <TerritoryMapContent />
      </Map>
    </Card>
  );
};
